import { Button, Card, Col, Input, InputNumber, Row } from "antd";
import React, { useState } from "react";

import { RiAddCircleFill } from "react-icons/ri";
import { CgCloseO } from "react-icons/cg";
import { TbCurrencyDollar } from "react-icons/tb";

import "./AdditionalIncome.css";

function AdditionalIncome({ data }) {
  const [checked, setChecked] = useState(false);

  const [additionalIncome, setAdditionalIncome] = useState([
    {
      monthlyIncome: "",
      source: "",
    },
  ]);

  const addAnotherAdditionalIncome = () => {
    setAdditionalIncome([
      ...additionalIncome,

      {
        monthlyIncome: "",
        source: "",
      },
    ]);
  };

  const onRemoveAdditionalIncome = (index) => {
    const newAdditionalIncome = [...additionalIncome];
    newAdditionalIncome.splice(index, 1);
    setAdditionalIncome(newAdditionalIncome);
  };
  return (
    <Row className="additional-income">
      <Col span={24}>
        <Card
          title="Additional Income"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <Row justify="start" gutter={[8, 0]}>
                  <Col className="header-row" span={12}>
                    <span>Monthly Income</span>
                  </Col>
                  <Col className="header-row" span={11}>
                    <span>Source</span>
                  </Col>
                </Row>
              </Col>
              {additionalIncome.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[8, 0]} align="middle">
                      <Col span={12}>
                        <InputNumber
                          placeholder="Monthly Income"
                          addonBefore={<TbCurrencyDollar size={16} />}
                          style={{ width: "100%" }}
                        />
                      </Col>
                      <Col span={11}>
                        <Input placeholder="Source" style={{ width: "100%" }} />
                      </Col>
                      {additionalIncome.length > 1 ? (
                        <Col span={1}>
                          <CgCloseO
                            className="delete-btn"
                            size={20}
                            onClick={() => onRemoveAdditionalIncome(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  onClick={() => addAnotherAdditionalIncome()}
                  className="add-icon-btn"
                >
                  <RiAddCircleFill size={18} />
                  <span>Add Another Additional Income</span>
                </button>
              </Col>
              <Col span={24} className="buttons-container">
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Row>
              {data?.length >= 1 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <Row gutter={[8, 0]} className="header-row">
                        <Col span={12}>
                          <span>Monthly Income</span>
                        </Col>
                        <Col span={12}>
                          <span>Source</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  {data?.map((item, index) => {
                    return (
                      <Row gutter={[8, 0]} className="data-row" key={index}>
                        <Col span={6}>
                          <span>{item.make}</span>
                        </Col>
                        <Col span={6}>
                          <span>{item.model}</span>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : (
                <Col span={24}>
                  <Row justify="center">
                    <Col>
                      <p>Click edit to add additional income.</p>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default AdditionalIncome;
